import React from "react";
import { MenuItem, Select, InputLabel, FormControl, Chip, Box, OutlinedInput } from "@mui/material";

const CategoryClip = ({ categories, selectedCategories, setSelectedCategories }) => {
  const handleSelect = event => {
    const value = event.target.value;
    if (value.includes("All")) {
      setSelectedCategories(selectedCategories.length === categories.length ? [] : [...categories]);
    } else {
      setSelectedCategories(categories.filter(cat => value.includes(cat.categoryId)));
    }
  };

  const handleDelete = id => {
    setSelectedCategories(prevSelected => prevSelected.filter(cat => cat.categoryId !== id));
  };

  return (
    <FormControl fullWidth className='select-category'>
      <InputLabel className='select-category-lable'>Product Category *</InputLabel>
      <Select
        multiple
        // required
        value={selectedCategories.map(cat => cat.categoryId)} // Store only IDs in Select
        onChange={handleSelect}
        input={<OutlinedInput label='Product Category *' />}
        className="category-box"
        // renderValue={(selected) => (
        //   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        //     {selectedCategories.map((cat) => (
        //       <Chip key={cat.id} label={cat.name} onDelete={() => handleDelete(cat.id)} />
        //     ))}
        //   </Box>
        // )}
      >
        {/* Select All Option */}
        <MenuItem value='All'>
          {selectedCategories.length === categories.length ? "Deselect All" : "Select All"}
        </MenuItem>

        {/* Individual Category Options */}
        {categories.map(category => (
          <MenuItem key={category.categoryId} value={category.categoryId}>
            {category.nameEn}
          </MenuItem>
        ))}
      </Select>

      {/* Show selected categories as removable MUI Chips below the dropdown */}
      <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selectedCategories.map(cat => (
          <Chip
            key={cat.categoryId}
            label={cat.nameEn}
            style={{ borderRadius: "6px" }}
            onDelete={() => handleDelete(cat.categoryId)}
          />
        ))}
      </Box>
    </FormControl>
  );
};

export default CategoryClip;
